<div class="common-section">
    <app-business-flow-form></app-business-flow-form>
</div>